import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  constructor(private notification: NotificationService) {}

  handle(error: any) {
    console.error('HTTP Error:', error);

    const message = this.getFriendlyMessage(error);
    this.notification.error(message);

    return throwError(() => error);
  }

  private getFriendlyMessage(error: HttpErrorResponse): string {    
    let message = 'An unknown error occurred.';
    switch (error.status) {
      case 400:
        message = 'Bad request. Please check your input.';
        break;
      case 401:
        message = 'Unauthorized. Please log in again.';
        break;
      case 403:
        message = 'Forbidden. You do not have permission to access this resource.';
        break;
      case 404:
        message = 'Not found. The requested resource could not be found.';
        break;
      case 500:
        message = 'Internal server error. Please try again later.';
        break;
    }
    return message;
  }
}
